import { BaseAction } from '../core';
import { RollupData } from './types';

export type DashboardAction =
  | BaseAction<'DASHBOARD_SET_VISIT_OVERVIEW_IS_FETCHING', { date: string; value: boolean }>
  | BaseAction<'DASHBOARD_SET_VISIT_OVERVIEW', { date: string; value: RollupData[] }>;

export function setVisitOverviewFetching(date: string, value: boolean): BaseAction<'DASHBOARD_SET_VISIT_OVERVIEW_IS_FETCHING', { date: string; value: boolean }> {
  return {
    type: 'DASHBOARD_SET_VISIT_OVERVIEW_IS_FETCHING',
    data: { date, value },
  };
}

export function setVisitOverview(date: string, value: RollupData[]): BaseAction<'DASHBOARD_SET_VISIT_OVERVIEW', { date: string; value: RollupData[] }> {
  return {
    type: 'DASHBOARD_SET_VISIT_OVERVIEW',
    data: { date, value },
  };
}
